import * as React from 'react'

export const ExclamationMark = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6 0C2.672 0 0 2.695 0 6c0 3.328 2.672 6 6 6 3.305 0 6-2.672 6-6 0-3.305-2.695-6-6-6Zm0 11.25A5.241 5.241 0 0 1 .75 6 5.256 5.256 0 0 1 6 .75c2.883 0 5.25 2.367 5.25 5.25A5.256 5.256 0 0 1 6 11.25Zm0-6.938a.555.555 0 0 0 .562-.562A.57.57 0 0 0 6 3.187a.555.555 0 0 0-.563.563c0 .328.235.563.563.563ZM7.125 8.25h-.75V5.625A.403.403 0 0 0 6 5.25h-.75a.385.385 0 0 0-.375.375A.37.37 0 0 0 5.25 6h.375v2.25h-.75a.385.385 0 0 0-.375.375.37.37 0 0 0 .375.375h2.25a.385.385 0 0 0 .375-.375.403.403 0 0 0-.375-.375Z"
      fill="currentColor"
    />
  </svg>
)
